import styles from './MyOrders.module.css';
const $ = window.$
const list = ["Open Orders", "Cancelled orders", "Completed Orders"]

 
const myOrders = (props) => {
    return (
        <>
            <div class="container" style={{ marginTop: "20px", marginBottom: "20px" }}>
                <ul class="nav nav-pills mb-3" id="pills-tab" role="tablist">
                    <li class="nav-item" role="presentation">
                        <a class="nav-link active" id="pills-home-tab" data-toggle="pill" href="#pills-home" role="tab" aria-controls="pills-home" aria-selected="true">Ongoing Orders</a>
                    </li>
                    <li class="nav-item" role="presentation">
                        <a class="nav-link" id="pills-profile-tab" data-toggle="pill" href="#pills-profile" role="tab" aria-controls="pills-profile" aria-selected="false">Completed Orders</a>
                    </li>
                    <li class="nav-item" role="presentation">
                        <a class="nav-link" id="pills-contact-tab" data-toggle="pill" href="#pills-contact" role="tab" aria-controls="pills-contact" aria-selected="false">Cancelled Orders</a>
                    </li>
                </ul>
                <div class={"tab-content "+styles.Tab} id="pills-tabContent">
                    <div class="tab-pane fade show active" id="pills-home" role="tabpanel" aria-labelledby="pills-home-tab">
                        <div style={{ border: "1px solid grey", boxShadow: "1px 1px 5px grey", borderRadius: "5px", padding: "5px 10px", marginBottom:"5px" }}>
                            <p>Order Id: YD-D6CEC1F97AB5FC6ED</p>
                            <p>Services: Open RO Installation,Open RO Replacement</p>
                            <p>Date: 17/1/2021</p>
                            <button class="btn btn-warning">Write Review</button>
                            <p>Star Ratings</p>
                        </div>
                    </div>


                    <div class="tab-pane fade" id="pills-profile" role="tabpanel" aria-labelledby="pills-profile-tab">
                    <div style={{ border: "1px solid grey", boxShadow: "1px 1px 5px grey", borderRadius: "5px", padding: "5px 10px", marginBottom:"10px" }}>
                            <p>Order Id: YD-D6CEC1F97AB5FC6ED</p>
                            <p>Services: Open RO Installation,Open RO Replacement</p>
                            <p>Date: 17/1/2021</p>
                            <button class="btn btn-warning">Write Review</button>
                            <p>Star Ratings</p>
                        </div>
                        <div style={{ border: "1px solid grey", boxShadow: "1px 1px 5px grey", borderRadius: "5px", padding: "5px 10px", marginBottom:"10px" }}>
                            <p>Order Id: YD-D6CEC1F97AB5FC6ED</p>
                            <p>Services: Open RO Installation,Open RO Replacement</p>
                            <p>Date: 17/1/2021</p>
                            <button class="btn btn-warning">Write Review</button>
                            <p>Star Ratings</p>
                        </div>
                    </div>
                    <div class="tab-pane fade" id="pills-contact" role="tabpanel" aria-labelledby="pills-contact-tab">
                        ...
                        </div>
                </div>
            </div>
        </>
    );
}

export default myOrders;